import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

const coachesData = [
    {
        id: 1,
        name: 'John Doe',
        phone: '081234567890',
        specialty: 'Beginner',
        status: 'Active',
    },
    {
        id: 2,
        name: 'Jane Smith',
        phone: '089876543210',
        specialty: 'Intermediate',
        status: 'Active',
    },
    {
        id: 3,
        name: 'Peter Jones',
        phone: '081122334455',
        specialty: 'Advanced',
        status: 'Inactive',
    },
];

const Coaches = ({ user, onLogout }) => {
    const [isSidebarOpen, setSidebarOpen] = useState(false);
    const [isModalOpen, setModalOpen] = useState(false);
    const [coaches, setCoaches] = useState(coachesData);
    const [newCoach, setNewCoach] = useState({ name: '', phone: '', specialty: '' });

    const toggleSidebar = () => {
        setSidebarOpen(!isSidebarOpen);
    };

    const toggleModal = () => {
        setModalOpen(!isModalOpen);
    };

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setNewCoach({ ...newCoach, [id]: value });
    };

    const handleAddCoach = () => {
        setCoaches([...coaches, { ...newCoach, id: coaches.length + 1, status: 'Active' }]);
        setNewCoach({ name: '', phone: '', specialty: '' });
        toggleModal();
    };

    return (
        <div id="admin-container" className="flex">
            {isSidebarOpen && <div className="fixed inset-0 bg-black opacity-50 z-30 lg:hidden" onClick={toggleSidebar}></div>}
            <Sidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
            <main id="main-content" className={`flex-1 lg:ml-64 transition-all duration-300 ease-in-out ${isSidebarOpen ? 'lg:ml-64' : 'lg:ml-0'}`}>
                <Header user={user} onLogout={onLogout} toggleSidebar={toggleSidebar} title="Pelatih" />
            </main>
        </div>
    );
};

export default Coaches;